import script from "./ContentWorkflow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentWorkflow.vue?vue&type=script&lang=ts&setup=true"

import "./ContentWorkflow.vue?vue&type=style&index=0&id=0fc72d89&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc72d89"]])

export default __exports__